module.exports = __webpack_public_path__ + "static/media/battery.6fd0b360.png";